import React from "react";
import Switch from "../Switch/Switch";
import UserSelect from "../Selects/UserSelect";

class ProductServicesPanel extends React.Component {

    constructor(props)  {
        super(props);
        this.serviceRequiredOnChange = this.serviceRequiredOnChange.bind(this)
        this.userOnChange = this.userOnChange.bind(this)
    };

    render() {
        return(
            <div>
            {this.renderProductServiceRequiredPanel(this.props.product, this.props.idx)}
            {
            this.props.product && this.props.product.requires_service_request
            ?
            this.renderServiceRequiredForm(this.props.product, this.props.idx)
            :
            null
            }
            </div>
        );
    };

    renderProductServiceRequiredPanel(product, idx) {
        return (
             <div>
              <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('service')} </h5>
              <div className="row">
                <div className="form-group">
                  <div className={this.props.read_only != true && this.props.remove ? "col-sm-12" : "col-sm-12"}>
                    <label>{I18n.t('does_this_product_require_service_request')}</label>
                    <br style={{ lineHeight: '30px' }} />
                    {
                      this.props.read_only || (this.props.mode != 'single' && product.id > 0)
                      ?
                      <div className="read-only-text">{product.requires_service_request ? I18n.t('yes') : I18n.t('no')}</div>
                      :
                      <div>
                        <Switch onText="yes" switchId="require-service-request-switch" offText="no" name="requires_service_request" value={this.props.product && this.props.product.requires_service_request ? this.props.product.requires_service_request  : false} onChange={this.serviceRequiredOnChange}  />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
        );
    };

    renderServiceRequiredForm(product, idx) {
        return (
            <div className="card service-required-well">
                <div className="row">
                    <div className="col-md-12">
                        <label>{I18n.t('assigned_to')}* <span className="ss-help help" title={I18n.t('default_user_helper_text')}></span></label>
                        <div className="form-group">
                            {
                                this.props.read_only || (this.props.mode != 'single' && product.id > 0)
                                    ?
                                        this.props.default_assigned_to
                                        ?
                                        <div>{this.props.default_assigned_to ? this.props.default_assigned_to.name : null}</div>
                                        :
                                        <div>{product.assigned_to_name ? product.assigned_to_name : null}</div>
                                    :
                                    <UserSelect user={this.props.product && this.props.product.default_assigned_to ? this.props.product.default_assigned_to : '' } menu_item={this.props.menu_item} onChange={this.userOnChange} />
                            }
                            {this.props.renderFieldErrors('default_assigned_to')}

                        </div>
                        <label>{I18n.t('service_request_description')}</label>
                        <textarea  defaultValue={this.props.product.special_instructions} rows="3" className="form-control" onChange={this.props.onChangeInstructions}></textarea>
                    </div>
                </div>
            </div>

        );
    };

    serviceRequiredOnChange(input) {
      this.props.onChangeSwitch('requires_service_request', input.target.checked )
    };

  userOnChange(value) {
    this.props.onChangeSwitch('default_assigned_to', value )
  };

};

export default ProductServicesPanel
